/**
 * Age Range Utility
 * Calculates age range group based on date of birth
 */

export enum AgeRange {
  RANGE_16_17 = 'RANGE_16_17', // 16 a 17 anos
  RANGE_18_24 = 'RANGE_18_24', // 18 a 24 anos
  RANGE_25_34 = 'RANGE_25_34', // 25 a 34 anos
  RANGE_35_44 = 'RANGE_35_44', // 35 a 44 anos
  RANGE_45_54 = 'RANGE_45_54', // 45 a 54 anos
  RANGE_55_64 = 'RANGE_55_64', // 55 a 64 anos
  RANGE_65_PLUS = 'RANGE_65_PLUS', // Acima de 65 anos
}

export const AGE_RANGE_LABELS: Record<AgeRange, string> = {
  [AgeRange.RANGE_16_17]: '16 a 17 anos',
  [AgeRange.RANGE_18_24]: '18 a 24 anos',
  [AgeRange.RANGE_25_34]: '25 a 34 anos',
  [AgeRange.RANGE_35_44]: '35 a 44 anos',
  [AgeRange.RANGE_45_54]: '45 a 54 anos',
  [AgeRange.RANGE_55_64]: '55 a 64 anos',
  [AgeRange.RANGE_65_PLUS]: 'Acima de 65 anos',
};

/**
 * Calculate age range from date of birth
 * @param dateOfBirth - Date of birth (Date object or ISO string)
 * @returns Age range enum value
 */
export function calculateAgeRange(dateOfBirth: Date | string): AgeRange {
  const dob = typeof dateOfBirth === 'string' ? new Date(dateOfBirth) : dateOfBirth;
  const today = new Date();
  
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  
  // Adjust age if birthday hasn't occurred this year
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  if (age < 16) return AgeRange.RANGE_16_17;
  if (age <= 17) return AgeRange.RANGE_16_17;
  if (age <= 24) return AgeRange.RANGE_18_24;
  if (age <= 34) return AgeRange.RANGE_25_34;
  if (age <= 44) return AgeRange.RANGE_35_44;
  if (age <= 54) return AgeRange.RANGE_45_54;
  if (age <= 64) return AgeRange.RANGE_55_64;
  return AgeRange.RANGE_65_PLUS;
}

/**
 * Get label for age range
 * @param ageRange - Age range enum
 * @returns User-friendly label
 */
export function getAgeRangeLabel(ageRange: AgeRange): string {
  return AGE_RANGE_LABELS[ageRange];
}
